import React from 'react';
import * as ds from './dataService';
import {
  SelectFolderField,
  UploadDocumentsField
} from 'modules/components/layer04';
import { FormBaseLayout } from 'modules/components/layer10';



export type CreateDocumentsFormProps = {
  id: string;
  projectId?: string;
  folderId?: string;
  handleClose: () => void;
};

export const FC = (props: CreateDocumentsFormProps) => {
  const [
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    fnCreateDocumentsForm,
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    { loading }
  ] = ds.useCreateDocuments();

  const form = ds.useFormState(props.projectId ?? '', props.folderId ?? '');

  const handleSubmit = () => {
    props.handleClose();
  };


  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit();
      }}
      ignoreCancel={true}
      successButtonText='Done'
      isLoading={form.formState.isUploading}
    >
      <SelectFolderField.FC
        form={form}
        fieldName='folderId'
      />
      <UploadDocumentsField.FC
        form={form}
        fieldName='apiFileIds'
        uploadInProgressFieldName='isUploading'
      />
    </FormBaseLayout.FC>

  );
};
